
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("lbwJ2"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("lbwJ2", function(module, exports) {

let $f6c4029eac7be581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6c4029eac7be581$var$load("h3ABO"),
    $f6c4029eac7be581$var$load("kIM9N"),
    $f6c4029eac7be581$var$load("aNhGE"),
    $f6c4029eac7be581$var$load("djHM5"),
    $f6c4029eac7be581$var$load("eJQji"),
    $f6c4029eac7be581$var$load("2YffH"),
    $f6c4029eac7be581$var$load("9slUK"),
    $f6c4029eac7be581$var$load("6mHrv"),
    $f6c4029eac7be581$var$load("awWN9"),
    $f6c4029eac7be581$var$load("9CYct"),
    $f6c4029eac7be581$var$load("gQllS"),
    $f6c4029eac7be581$var$load("bxrdv"),
    $f6c4029eac7be581$var$load("hZtKG"),
    $f6c4029eac7be581$var$load("iNmaF"),
    $f6c4029eac7be581$var$load("lVO3w"),
    $f6c4029eac7be581$var$load("hyzoX"),
    $f6c4029eac7be581$var$load("h9Ed7"),
    $f6c4029eac7be581$var$load("eBRUf"),
    $f6c4029eac7be581$var$load("kbRvk"),
    $f6c4029eac7be581$var$load("k8QRJ"),
    $f6c4029eac7be581$var$load("43bfx"),
    $f6c4029eac7be581$var$load("cD6Zr"),
    $f6c4029eac7be581$var$load("9wzNh"),
    $f6c4029eac7be581$var$load("8YSo7"),
    $f6c4029eac7be581$var$load("3Zfzp"),
    $f6c4029eac7be581$var$load("9ldRJ"),
    $f6c4029eac7be581$var$load("50ame"),
    $f6c4029eac7be581$var$load("e7ZUf"),
    $f6c4029eac7be581$var$load("gL8bn"),
    $f6c4029eac7be581$var$load("ebWFc"),
    $f6c4029eac7be581$var$load("6iz6l"),
    $f6c4029eac7be581$var$load("4SCW2"),
    $f6c4029eac7be581$var$load("8bXcu"),
    $f6c4029eac7be581$var$load("1YiFu"),
    $f6c4029eac7be581$var$load("hv4mn"),
    $f6c4029eac7be581$var$load("Wowvf"),
    $f6c4029eac7be581$var$load("dek7I"),
    $f6c4029eac7be581$var$load("3SmkN"),
    $f6c4029eac7be581$var$load("dYtBN"),
    $f6c4029eac7be581$var$load("kNV5Y"),
    $f6c4029eac7be581$var$load("6wr18"),
    $f6c4029eac7be581$var$load("kjZZD"),
    $f6c4029eac7be581$var$load("2zxmz"),
    $f6c4029eac7be581$var$load("7269o"),
    $f6c4029eac7be581$var$load("3JSgG"),
    $f6c4029eac7be581$var$load("37ldp"),
    $f6c4029eac7be581$var$load("ffEVr"),
    $f6c4029eac7be581$var$load("dRpV3"),
    $f6c4029eac7be581$var$load("dTsOE"),
    $f6c4029eac7be581$var$load("hhss7"),
    $f6c4029eac7be581$var$load("jYUNl"),
    $f6c4029eac7be581$var$load("foy8I"),
    $f6c4029eac7be581$var$load("jY21r"),
    $f6c4029eac7be581$var$load("dP7ao"),
    $f6c4029eac7be581$var$load("hogcU"),
    $f6c4029eac7be581$var$load("i8eeg"),
    $f6c4029eac7be581$var$load("iFdoJ"),
    $f6c4029eac7be581$var$load("7EorR"),
    $f6c4029eac7be581$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.52bf3054.js.map
